import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export function useDeleteUserMutation() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async () => {
      const token = await getToken();
      return deleteUser(token ?? '');
    },
  });
}

const deleteUser = async (token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/users`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};
